import React, { useState, useEffect, useCallback } from 'react';
import {
    Grid,
    Box,
    Typography,
    Button,
    Snackbar,
    Alert,
    CircularProgress,
    Modal,
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Chip,
    Card,
    CardContent
} from '@mui/material';
import { API_KEY } from '../../../constants';
import axios from 'axios';
import CopyAllOutlinedIcon from '@mui/icons-material/CopyAllOutlined';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import PricingDetails from '../../../components/price_details';
import DiscountVoucher from '../../../components/discount_voucher';
import subscribeApi from '../../../services/subscribe';
import offerApi from '../../../services/offer';
import userApi from '../../../services/users';
import subscriptionApi from '../../../services/subscribe';
import { useDispatch, useSelector } from 'react-redux';
import { showLoader, hideLoader } from '../../../redux/loader/actions';
import { showSnackbar } from '../../../redux/snackbar/actions';
import moment from 'moment';
import { setEncryptedCookie, getDecryptedCookie, removeCookie } from '../../../utils';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2)',
        padding: '15px',
        position: 'relative',
        width: '90%',
        maxWidth: '800px'
    },
    paymentButton: {
        height: '100%',
        width: '100%',
        background: 'linear-gradient(45deg, #006400 30%, #008000 90%)',
        color: '#fff',
        borderRadius: '8px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background 0.3s, box-shadow 0.3s',
        '&:hover': {
            background: 'linear-gradient(45deg, #008000 30%, #006400 90%)',
            boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.3)'
        }
    },
    table: {
        minWidth: 350,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '1px solid #ddd'
    },
    tableHead: {
        backgroundColor: '#ffdedb',
        color: '#fff'
    },
    tableRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    tableCell: {
        padding: '12px 16px',
        fontWeight: '500'
    },
    closeButton: {
        position: 'absolute',
        top: 8,
        right: 0,
        color: theme.palette.text.primary,
        zIndex: 1000
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}));

const PricingModal = ({
    open,
    onClose,
    productName,
    frequencyType,
    productDetails,
    setProductDetails,
    selectedPlanDetails,
    setSelectedPlanDetails,
    pricing,
    setPricing,
    setShowTrialDetails,
    actionType,
    subUUID,
    setSubUUID,
    busUUID,
    setBusUUID,
    planData,
    planId,
    renewPlan
}) => {
    const dispatch = useDispatch();
    const organizationItems = useSelector((state) => state.organizationReducer.items);
    const classes = useStyles();
    const navigate = useNavigate();
    const businessUUID = getDecryptedCookie('bi');
    const proid = getDecryptedCookie('proid');

    const action = getDecryptedCookie('upgrade');
    const buuid = getDecryptedCookie('buuid');
    const suuid = getDecryptedCookie('suuid');
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [discount, setDiscount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [paymentInProgress, setPaymentInProgress] = useState(false);
    const [specificOffer, setSpecificOffer] = useState();
    const [generalOffer, setGeneralOffer] = useState();
    const [copied, setCopied] = useState(false);
    const [voucher, setVoucher] = useState('');
    const [copiedCode, setCopiedCode] = useState(null);
    const [totalAmt, setTotalAmt] = useState();
    const [offerType, setOfferType] = useState();
    const [ownerDetails, setOwnerDetails] = useState();
    const OwnerDetails = () => {
        const onSuccess = (res) => {
            if (res?.data?.status) {
                setOwnerDetails(res?.data?.data);
                sessionStorage.setItem('organisationName', res?.data?.data?.uuid);
            }
        };
        const onFailure = (err) => {
            console.log(err);
        };
        userApi?.getOwnerDetails().then(onSuccess, onFailure);
    };
    useEffect(() => {
        OwnerDetails();
    }, []);

    const handleSelectPlan = (index) => setSelectedPlan(index === selectedPlan ? null : index);

    const applyDiscount = (voucher) => setDiscount(voucher === 'DISCOUNT10' ? 10 : 0);

    const [paymentData, setPayamentData] = useState();
    const [orderId, setOrderId] = useState();

    const handlePaymentClick = () => {
        dispatch(showLoader());
        const data = {
            business_uuid: busUUID,
            prd_plan_pricing_uuid: pricing?.prd_plan_pricing_uuid ? pricing?.prd_plan_pricing_uuid : null,
            renewal_type: 'none',
            subscription_type: 'subscription',
            purchase_type: 'renew',
            product_plan_uuid: selectedPlanDetails ? selectedPlanDetails?.product_plan_uuid : planId,
            total_amount: parseFloat(totalAmt.toFixed(2)),
            offer_uuid: voucher ? voucher?.uuid : null,
            offer_type: voucher ? offerType : null,
            subscription_uuid: subUUID
        };
        setEncryptedCookie('buslap', actionType === 'upgrade' ? action : businessUUID);

        const onSuccess = (res) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: res?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'success'
                })
            );
            setOrderId(res?.data?.subscription_order_uuid);
            setPayamentData(res?.data?.order);
            openRazorpayModal(res?.data);
        };

        const onFailure = (err) => {
            dispatch(hideLoader());
            dispatch(
                showSnackbar({
                    message: err?.response?.data?.msg,
                    autoHideDuration: 3000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    variant: 'error'
                })
            );
            console.error('Failed', err);
        };

        subscribeApi.createSubscription(data).then(onSuccess, onFailure);
    };
    const openRazorpayModal = async (orderData) => {
        try {
            const amountInPaise = orderData.amount * 100;
            const options = {
                key: API_KEY.RAZOR_KEY,
                amount: orderData?.order?.amount,
                currency: orderData.order?.currency || 'INR',
                name: 'TAGITStore',
                description: 'Live',
                order_id: orderData.order?.id,
                handler: async function (response) {
                    try {
                        dispatch(showLoader());
                        const data = {
                            order_uuid: orderData?.subscription_order_uuid,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature
                        };
                        const verifyResponse = await subscribeApi?.paymentVerification(data);

                        if (verifyResponse.data.status) {
                            dispatch(hideLoader());
                            dispatch(
                                showSnackbar({
                                    message: verifyResponse?.data?.msg,
                                    autoHideDuration: 3000,
                                    anchorOrigin: {
                                        vertical: 'top',
                                        horizontal: 'right'
                                    },
                                    variant: 'success'
                                })
                            );

                            if (actionType === 'upgrade' || actionType === 'renew') {
                                navigate(
                                    `/subscriptions/manageproducts/productconfig/${proid}/${
                                        actionType === 'upgrade' || actionType === 'renew' ? busUUID : businessUUID
                                    }`
                                );
                            } else {
                                navigate(
                                    `/subscriptions/manageproducts/productconfig/${productDetails?.uuid}/${busUUID}`
                                );
                            }
                        } else {
                            dispatch(hideLoader());
                            alert('Payment verification failed. Please try again.');
                        }
                    } catch (verifyError) {
                        dispatch(hideLoader());
                        console.error('Payment verification error:', verifyError);
                        alert(verifyError?.response?.data?.msg);
                    }
                },
                prefill: {
                    name: ownerDetails?.username,
                    email: ownerDetails?.email,
                    contact: ownerDetails?.mobile_number
                },
                theme: {
                    color: '#F37254'
                },
                config: {
                    display: {
                        hide: [{ method: 'paylater' }, { method: 'emi' }, { method: 'wallet' }],
                        preferences: { show_default_blocks: true }
                    }
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();
            setOwnerDetails();
        } catch (error) {
            console.error('Error during payment process:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const handleCloseSnackbar = () => setOpenSnackbar(false);

    useEffect(() => {
        if (selectedPlan !== null) setDiscount(0);
    }, [selectedPlan, organizationItems]);

    const currentDate = new Date();

    const isOfferValid =
        pricing?.offer_valid_from &&
        pricing?.offer_valid_to &&
        moment.utc(pricing.offer_valid_from).startOf('day') <= currentDate &&
        currentDate <= moment.utc(pricing.offer_valid_to).endOf('day');

    const subtotal = isOfferValid ? pricing?.offer_price : pricing?.frequency_price;
    const totalPrice = subtotal;

    const getSpecificOfferData = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status) {
                setSpecificOffer(res?.data?.data);
            }
        };
        const onFailure = (err) => {
            console.log(err?.response?.data?.message);
        };
        offerApi?.getSpecificOffer().then(onSuccess, onFailure);
    };
    const getGeneralOfferData = () => {
        dispatch(showLoader());
        const onSuccess = (res) => {
            dispatch(hideLoader());
            if (res?.data?.status) {
                setGeneralOffer(res?.data?.data);
            }
        };
        const onFailure = (err) => {
            console.log(err?.response?.data?.message);
        };
        offerApi?.getGeneralOffer().then(onSuccess, onFailure);
    };

    useEffect(() => {
        if (open) {
            getSpecificOfferData();
            getGeneralOfferData();
        }
    }, [open, organizationItems]);
    const handleCopyClickGen = (offerCode) => {
        setOfferType();
        setVoucher(offerCode);
        setCopiedCode(offerCode?.offer_code);
        setCopied(true);
        setOfferType('general');
    };
    const handleCopyClickSpec = (offerCode) => {
        setOfferType();
        setVoucher(offerCode);
        setCopiedCode(offerCode?.offer_code);
        setCopied(true);
        setOfferType('specific');
    };

    const selectedPlanFrequency = pricing?.frequency;
    const selectedPlanUUID = selectedPlanDetails?.product_plan_uuid;

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.modal}
            BackdropProps={{
                onClick: (e) => e.stopPropagation()
            }}
        >
            <Box
                sx={{
                    bgcolor: 'background.paper',
                    p: 4,
                    borderRadius: 1,
                    boxShadow: 24,
                    outline: 'none',
                    position: 'relative',
                    width: { xs: '70%', sm: '90%' },
                    maxHeight: '80vh',
                    overflowY: 'auto'
                }}
            >
                <IconButton onClick={onClose} sx={{ position: 'absolute', top: 16, right: 16 }}>
                    <CloseIcon />
                </IconButton>
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={7}>
                            <Typography variant='h6' sx={{ fontWeight: 'bold', mb: 2 }}>
                                Product Details
                            </Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table className={classes.table} size='small'>
                                    <TableBody>
                                        <TableRow className={classes.tableRow}>
                                            <TableCell className={classes.tableCell}>
                                                <strong>Product Name</strong>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>{productDetails?.name}</TableCell>
                                        </TableRow>
                                        <TableRow className={classes.tableRow}>
                                            <TableCell className={classes.tableCell}>
                                                <strong>Selected Plan</strong>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                {selectedPlanDetails
                                                    ? selectedPlanDetails?.product_plan_name
                                                    : renewPlan?.product_plan_name}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className={classes.tableRow}>
                                            <TableCell className={classes.tableCell}>
                                                <strong>Frequency</strong>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                {pricing?.frequency?.charAt(0).toUpperCase() +
                                                    pricing?.frequency?.slice(1)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Grid container spacing={2} mt={1}>
                                {generalOffer?.length > 0 &&
                                    generalOffer.map((data, index) => {
                                        const generalOfferFrequency = data?.frequency;
                                        const generalOfferPlanUUID = data?.productPlanDetails?.product_plan_uuid;

                                        const selectedPlanFrequency = pricing?.frequency;
                                        const selectedPlanUUID = selectedPlanDetails?.product_plan_uuid;

                                        const isFrequencyMatch =
                                            generalOfferFrequency === selectedPlanFrequency &&
                                            generalOfferPlanUUID === selectedPlanUUID;

                                        if (!isFrequencyMatch) return null;

                                        return (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                {isFrequencyMatch && (
                                                    <Card
                                                        variant='outlined'
                                                        sx={{
                                                            position: 'relative',
                                                            borderRadius: '10px',
                                                            boxShadow: 3,
                                                            width: '200px',
                                                            height: '100px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'space-between',
                                                            padding: '8px',
                                                            overflow: 'hidden',
                                                            transition: '0.3s',
                                                            '&:hover': {
                                                                boxShadow: 8,
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                background: '#cfcfcf',
                                                                color: '#7b7b7b',
                                                                padding: '8px 12px',
                                                                writingMode: 'vertical-lr',
                                                                textAlign: 'center',
                                                                fontSize: '0.75rem',
                                                                fontWeight: 'bold',
                                                                borderRadius: '0 0px 8px 0'
                                                            }}
                                                        >
                                                            OFF
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'space-between',
                                                                // flexGrow: 1,
                                                                marginLeft: '40px'
                                                            }}
                                                        >
                                                            <Typography
                                                                variant='subtitle1'
                                                                sx={{
                                                                    fontWeight: 'bold',
                                                                    fontSize: '0.9rem',
                                                                    color: '#2C3E50',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                {data.offer_title}
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='textSecondary'
                                                                sx={{
                                                                    fontSize: '0.75rem',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                {data.offer_description} (General Off)
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='textSecondary'
                                                                sx={{
                                                                    fontSize: '0.75rem',
                                                                    fontWeight: 'bold'
                                                                    // marginTop: "4px",
                                                                }}
                                                            >
                                                                Offer Price:{' '}
                                                                {data?.offer_discount_type === 'rupee' ? '₹' : ''}
                                                                {data.offer_discount}
                                                                {data?.offer_discount_type === 'percentage' ? '%' : ''}
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='primary'
                                                                sx={{
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '4px'
                                                                }}
                                                            >
                                                                Code: {data.offer_code}
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            variant='contained'
                                                            color='primary'
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                                fontWeight: 'bold',
                                                                textTransform: 'uppercase',
                                                                background:
                                                                    'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
                                                                padding: '4px 6px',
                                                                minWidth: 'unset',
                                                                color: '#fff',
                                                                alignSelf: 'flex-end',
                                                                marginTop: 'auto'
                                                            }}
                                                            onClick={() => handleCopyClickGen(data)}
                                                        >
                                                            Apply
                                                        </Button>
                                                    </Card>
                                                )}
                                            </Grid>
                                        );
                                    })}
                                <Snackbar
                                    open={copied}
                                    autoHideDuration={2000}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right'
                                    }}
                                    onClose={() => setCopied(false)}
                                >
                                    <Alert onClose={() => setCopied(false)} severity='success' sx={{ width: '100%' }}>
                                        {`Voucher "${copiedCode}" applied!`}
                                    </Alert>
                                </Snackbar>
                                {specificOffer?.length > 0 &&
                                    specificOffer.map((data, index) => {
                                        const specificOfferPlanUUID = data?.productPlanDetails?.product_plan_uuid;
                                        const selectedPlanUUID = selectedPlanDetails?.product_plan_uuid;

                                        const isFrequencyMatch = specificOfferPlanUUID === selectedPlanUUID;
                                        if (!isFrequencyMatch) return null;

                                        return (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                {isFrequencyMatch && (
                                                    <Card
                                                        variant='outlined'
                                                        sx={{
                                                            position: 'relative',
                                                            borderRadius: '10px',
                                                            boxShadow: 3,
                                                            width: '200px',
                                                            height: '100px',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'space-between',
                                                            padding: '8px',
                                                            overflow: 'hidden',
                                                            transition: '0.3s',
                                                            '&:hover': {
                                                                boxShadow: 8,
                                                                transform: 'scale(1.05)'
                                                            }
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                background: '#cfcfcf',
                                                                color: '#7b7b7b',
                                                                padding: '8px 12px',
                                                                writingMode: 'vertical-lr',
                                                                textAlign: 'center',
                                                                fontSize: '0.75rem',
                                                                fontWeight: 'bold',
                                                                borderRadius: '0 0px 8px 0'
                                                            }}
                                                        >
                                                            OFF
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                justifyContent: 'space-between',
                                                                marginLeft: '40px'
                                                            }}
                                                        >
                                                            <Typography
                                                                variant='subtitle1'
                                                                sx={{
                                                                    fontWeight: 'bold',
                                                                    fontSize: '0.9rem',
                                                                    color: '#2C3E50',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                {data.offer_title}
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='textSecondary'
                                                                sx={{
                                                                    fontSize: '0.75rem',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                {data.offer_description} (Specific Off)
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='textSecondary'
                                                                sx={{
                                                                    fontSize: '0.75rem',
                                                                    fontWeight: 'bold'
                                                                }}
                                                            >
                                                                Offer Price:{' '}
                                                                {data?.offer_discount_type === 'rupee' ? '₹' : ''}
                                                                {data.offer_discount}
                                                                {data?.offer_discount_type === 'percentage' ? '%' : ''}
                                                            </Typography>
                                                            <Typography
                                                                variant='body2'
                                                                color='primary'
                                                                sx={{
                                                                    fontSize: '0.85rem',
                                                                    fontWeight: 'bold',
                                                                    marginTop: '4px'
                                                                }}
                                                            >
                                                                Code: {data.offer_code}
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            variant='contained'
                                                            color='primary'
                                                            sx={{
                                                                fontSize: '0.75rem',
                                                                fontWeight: 'bold',
                                                                textTransform: 'uppercase',
                                                                background:
                                                                    'linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)',
                                                                padding: '4px 6px',
                                                                minWidth: 'unset',
                                                                color: '#fff',
                                                                alignSelf: 'flex-end',
                                                                marginTop: 'auto'
                                                            }}
                                                            onClick={() => handleCopyClickSpec(data)}
                                                        >
                                                            Apply
                                                        </Button>
                                                    </Card>
                                                )}
                                            </Grid>
                                        );
                                    })}
                                <Snackbar
                                    open={copied}
                                    autoHideDuration={2000}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right'
                                    }}
                                    onClose={() => setCopied(false)}
                                >
                                    <Alert onClose={() => setCopied(false)} severity='success' sx={{ width: '100%' }}>
                                        {`Voucher "${copiedCode}" applied!`}
                                    </Alert>
                                </Snackbar>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Box sx={{ marginTop: '15px' }}>
                                <DiscountVoucher
                                    applyDiscount={applyDiscount}
                                    voucher={voucher}
                                    setVoucher={setVoucher}
                                />
                            </Box>
                            <Box sx={{ marginTop: '10px' }}>
                                <PricingDetails
                                    subtotal={subtotal}
                                    cgst={0}
                                    sgst={0}
                                    discount={discount}
                                    total={totalPrice}
                                    voucher={voucher}
                                    setTotalAmt={setTotalAmt}
                                    setVoucher={setVoucher}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{ marginLeft: 'auto' }}>
                            <Button className={classes.paymentButton} onClick={handlePaymentClick} variant='contained'>
                                Proceed to Pay
                            </Button>
                        </Grid>
                        {paymentInProgress && (
                            <Grid item xs={12} sm={4} className={classes.spinnerContainer}>
                                <CircularProgress size={50} />
                            </Grid>
                        )}
                    </Grid>
                </Box>
                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert onClose={handleCloseSnackbar} severity='info' sx={{ width: '100%' }}>
                        Payment Successful!
                    </Alert>
                </Snackbar>
            </Box>
        </Modal>
    );
};

export default PricingModal;
